import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import fireToastError from '../../actions/toasts/fireToastError'
import limitAccepted from '../../actions/userAccount/limit/limitAccepted'
import { IRequestLimits } from '../../actions/userAccount/limit/requestLimits'
import toggleLimitModal from '../../actions/userAccount/limit/toggleLimitModal'
import i18n from '../../i18n'
import { fetchLimit, ILimit } from '../../models/Limit'
import { ILimits } from '../../reducers/userAccount'
import { LimitActions } from '../../reducers/userAccount/actionNames'
import { getLimitsBorder } from '../../reducers/userAccount/selectors/getLimits'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { Mixpanel } from '../../utils/Mixpanel'
import { getUserId } from '../../reducers/userAccount/selectors/userAccount'

export enum LimitResponse {
  OK = 'clear to go',
  Rejected = 'Bruh, not cool',
}

function* limit(limits: ILimit, type: LimitType) {
  const premium = yield Effects.select(isLicenseValid)
  if (premium) {
    return LimitResponse.OK
  }
  const limitBorder: ILimits = yield Effects.select(getLimitsBorder)
  const exceeded = limits[type] >= limitBorder[type]
  const userId = yield Effects.select(getUserId)

  if (exceeded) {
    Mixpanel.people.increment(userId, 'Limits Screen View', 1)
    Mixpanel.track('Limits Screen View', {})
    yield Effects.put(toggleLimitModal(true))
  }

  return exceeded ? LimitResponse.Rejected : LimitResponse.OK
}

export function* loadLimits(type: LimitType) {
  try {
    const actionNames = fetchActionsName(ActionNames.LoadLimits)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(callFetch(actionNames.input, actionNames.output, fetchLimit)),
    ])

    const limits: ILimit[] = yield Effects.call(service)

    yield Effects.put(limitAccepted(limits[0]))

    return yield* limit(limits[0], type)
  } catch (e) {
    console.error(e)
    yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
    return LimitResponse.Rejected
  }
}

function* loadLimitsAction(action: IRequestLimits) {
  yield* loadLimits(action.limit)
}

export default function*() {
  yield Effects.takeEvery(LimitActions.RequestLimits, loadLimitsAction)
}

export enum LimitType {
  Add = 'add',
  Copy = 'copy',
  Transfer = 'transfer',
  Edit = 'edit',
}
